import { SharingType } from '@bringg/types';

export const SHARING_TYPES_WITH_DYNAMIC_DISPLAY_TYPE: SharingType[] = [
	SharingType.CustomWorkflow,
	SharingType.NotificationByTemplateId
];
